<template>
  <div class="cx-div" style="padding: 2rem">
    <content-placeholders :animated="false" :rounded="true">
      <content-placeholders-img />
      <content-placeholders-heading />
      <content-placeholders-heading :img="true" />
      <content-placeholders-text :lines="3" />
      <content-placeholders-heading />
      <content-placeholders-heading :img="true" />
      <content-placeholders-text :lines="3" />
      <content-placeholders-heading />
      <content-placeholders-heading :img="true" />
      <content-placeholders-text :lines="3" />
    </content-placeholders>
  </div>
</template>

<script>
export default {
  name: 'default-loading-placeholder'
}
</script>